export const blockIconsUiactionsStarNew = (
	<span className='material-symbols-outlined'>star</span>
);
